import { set } from 'cerebral/operators'

export default [set('login.recovery.snackbar.show', false)]



// WEBPACK FOOTER //
// ./src/modules/login/chains/unshowRecoverySnackbar.js